const AMR_MULTIPLIERS = {
    0: 0.0000001,
    1: 0.000001,
    2: 0.00001,
    3: 0.0001,
    4: 0.001,
    5: 0.01,
    6: 0.1,
    7: 1.0,
    8: 10.0,
    9: 100.0,
    10: 1000.0,
    11: 10000.0,
    12: 100000.0,
    13: 1000000.0,
    14: 10000000.0,
    15: 100000000.0
};

const LITERS_PER_CUBIC_METER = 1000;

const UNAVAILABLE_STATUSES = new Set([
    'record empty',
    'overflow',
    'read error',
    'digit error',
    'unavailable',
    'not_available',
    'not available',
    'not available / manufacturer-specific',
    'manufacturer-specific',
    'invalid'
]);

function normalizeStatus(value) {
    return String(value || '').trim().toLowerCase();
}

function readNumber(...values) {
    for (const value of values) {
        if (value === null || value === undefined || value === '') continue;
        const number = Number(value);
        if (Number.isFinite(number)) return number;
    }

    return null;
}

export function getAmrFactor(source = {}) {
    const additionalData = source.additional_data || source.additionalData || source.lastReadingAdditionalData || {};

    return readNumber(
        source.Factor,
        source.factor,
        source.readingFactor,
        additionalData.Factor,
        additionalData.factor
    );
}

export function getAmrMultiplier(source = {}) {
    const additionalData = source.additional_data || source.additionalData || source.lastReadingAdditionalData || {};
    const factor = getAmrFactor(source);

    if (factor !== null && AMR_MULTIPLIERS[factor] !== undefined) {
        return AMR_MULTIPLIERS[factor];
    }

    return readNumber(
        source.Multiplier,
        source.multiplier,
        source.readingMultiplier,
        additionalData.Multiplier,
        additionalData.multiplier
    );
}

export function hasAmrConversionMetadata(source = {}) {
    return getAmrMultiplier(source) !== null;
}

export function amrRawToM3(rawValue, source = {}) {
    const raw = readNumber(rawValue);
    if (raw === null) return null;

    const multiplier = getAmrMultiplier(source);
    if (multiplier === null) return null;

    return raw * multiplier / LITERS_PER_CUBIC_METER;
}

export function getArchiveRawValue(item) {
    return readNumber(item?.Raw, item?.raw, item?.Engineered, item?.engineered);
}

export function isUnavailableArchiveItem(item, archiveType = 'hourly') {
    if (!item || typeof item !== 'object') return true;

    const raw = getArchiveRawValue(item);
    const status = normalizeStatus(item.Status || item.status);

    if (status && status !== 'valid' && status !== 'ok' && UNAVAILABLE_STATUSES.has(status)) {
        return true;
    }

    if (archiveType === 'weekly') {
        return raw === 0x80000000 || raw === 0xFFFFFFFF;
    }

    return raw === 0xFFFF || raw === 0x8000 || raw === 0x8001 || raw === 0x8002 || raw === 0x8003;
}

export function archiveValueToM3(item, source = {}) {
    return amrRawToM3(getArchiveRawValue(item), source);
}

export function formatM3(value) {
    const number = Number(value);
    return Number.isFinite(number) ? `${number.toFixed(3)} m³` : '';
}
